export default __webpack_public_path__ + "static/media/icgLogo.f69fe74d.png";